import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { TTabs } from '../../q-a/qanda';
import { ReactComponent as ArrowDown } from '../../../assets/icons/arrow-down.svg';
import { BackDrop, DropDownButton } from '../../index';
import { QandaTabs } from '../../../constans/question-enums';

interface IProps {
  tabs: TTabs[];
  selected: string;
  selectTabHandler: (properties: QandaTabs) => void;
}


const TabNav: React.FC<IProps> = observer(({ tabs, selected, selectTabHandler }): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const getMobileDropDownCount = (): number => {
    const [ selectedTab ] = tabs.filter((tab) => tab.title === selected);
    return selectedTab?.questions.length || 0;
  };
  return (
    <section className="qanda-tabs-wrapper">
      <BackDrop isVisible={isOpen} backdropTop/>
      <DropDownButton
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        classException="mobile-dropdown-tab"
        rootClass="qanda__tabs-bar_mobile-dropdown"
      >
        <>{selected} ({getMobileDropDownCount()}) <ArrowDown/></>
      </DropDownButton>
      <ul className="qanda__tabs-bar">
        {
          tabs.map((tab: TTabs) => {
            const active = tab.title === selected ? 'active-tab' : '';
            return (
              <li key={tab.title} onClick={() => selectTabHandler(tab.title)} className="mobile-dropdown-tab">
                <button className={active}>
                  { tab.title } ({tab.questions.length})
                </button>
              </li>
            );
          })
        }
      </ul>
    </section>
  );
});
export default TabNav;
